import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const StudioContext = createContext(null);

const STORAGE_KEYS = {
  email: "authoros_email",
  plan: "authoros_plan_v2",
};

export function StudioProvider({ children }) {
  const [email, setEmail] = useState(() => localStorage.getItem(STORAGE_KEYS.email) || "");
  const [plan, setPlan] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEYS.plan);
      return raw ? JSON.parse(raw) : [];
    } catch (_e) {
      return [];
    }
  });

  useEffect(() => {
    if (email) localStorage.setItem(STORAGE_KEYS.email, email);
    else localStorage.removeItem(STORAGE_KEYS.email);
  }, [email]);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEYS.plan, JSON.stringify(plan));
  }, [plan]);

  const signIn = (value) => setEmail((value || "").trim());
  const signOut = () => {
    setEmail("");
    setPlan([]);
  };

  const itemKey = (item) => item.key || item.code;

  const addToPlan = (item) => {
    const key = itemKey(item);
    setPlan((prev) => {
      if (prev.find((p) => itemKey(p) === key)) return prev;
      return [...prev, { ...item, key }];
    });
  };

  const removeFromPlan = (key) => {
    setPlan((prev) => prev.filter((p) => itemKey(p) !== key));
  };

  const isInPlan = (key) => plan.some((p) => (p.key || p.code) === key);

  const clearPlan = () => setPlan([]);

  const value = useMemo(
    () => ({ email, plan, signIn, signOut, addToPlan, removeFromPlan, clearPlan, isInPlan }),
    [email, plan]
  );

  return <StudioContext.Provider value={value}>{children}</StudioContext.Provider>;
}

export function useStudio() {
  const ctx = useContext(StudioContext);
  if (!ctx) throw new Error("useStudio must be used within StudioProvider");
  return ctx;
}
